import React, { Component } from "react";
import * as Icon from "react-feather";
import moment from "moment";
import AttachmentChip from "./AttachmentChip";

function decodeEntities(s) {
	if (!s) return "";
	return s.replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#39;/g, "'");
}

function splitFrom(fromHeader) {
	if (!fromHeader) return { name: "(unknown)", email: "" };
	const m = fromHeader.match(/^\s*"?([^"<]+?)"?\s*<(.+?)>\s*$/);
	if (m) return { name: m[1].trim(), email: m[2].trim() };
	if (fromHeader.indexOf("@") !== -1) return { name: fromHeader.trim(), email: fromHeader.trim() };
	return { name: fromHeader.trim(), email: "" };
}

function avatarInitial(name, email) {
	const src = (name || email || "?").trim();
	return src.charAt(0).toUpperCase();
}

/**
 * Sanitize an HTML body for embedding. Strips <script>, on*= handlers, javascript: URLs.
 * This is a best-effort guard; for full safety move to DOMPurify if/when it ships in deps.
 */
function sanitizeHtml(html) {
	if (!html) return "";
	let cleaned = html;
	cleaned = cleaned.replace(/<\s*script[^>]*>[\s\S]*?<\s*\/\s*script\s*>/gi, "");
	cleaned = cleaned.replace(/<\s*style[^>]*>[\s\S]*?<\s*\/\s*style\s*>/gi, "");
	cleaned = cleaned.replace(/\son\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, "");
	cleaned = cleaned.replace(/(href|src)\s*=\s*("javascript:[^"]*"|'javascript:[^']*'|javascript:[^\s>]+)/gi, "$1=\"#\"");
	return cleaned;
}

class MessageCard extends Component {
	state = { expanded: !!this.props.expanded };

	toggle = () => {
		this.setState(s => ({ expanded: !s.expanded }));
	};

	onStarClick = e => {
		e.stopPropagation();
		const { message, onToggleStar } = this.props;
		if (onToggleStar) onToggleStar(message);
	};

	render() {
		const { message, accountId } = this.props;
		const { expanded } = this.state;
		const fromObj = splitFrom(decodeEntities(message.from));
		const dateStr = message.internalDate ? moment(Number(message.internalDate)).format("MMM D, YYYY · h:mm A") : message.date || "";
		const toStr = decodeEntities(message.to);
		const ccStr = decodeEntities(message.cc);
		const initials = avatarInitial(fromObj.name, fromObj.email);

		const html = expanded ? sanitizeHtml(message.bodyHtml || "") : "";
		const fallbackText = expanded && !message.bodyHtml ? message.bodyText : "";

		return (
			<div className={`message-card${expanded ? " is-expanded" : " is-collapsed"}`} onClick={!expanded ? this.toggle : undefined}>
				<div className="message-card__head" onClick={expanded ? this.toggle : undefined} style={{ cursor: "pointer" }}>
					<div className="message-card__avatar">{initials}</div>
					<div className="message-card__head-main">
						<div className="message-card__from">
							{fromObj.name}
							{fromObj.email && fromObj.email !== fromObj.name && <span className="message-card__from-email">&lt;{fromObj.email}&gt;</span>}
						</div>
						{expanded ? (
							<div className="message-card__to">
								{toStr && <>to {toStr}</>}
								{ccStr && <> · cc {ccStr}</>}
							</div>
						) : (
							<div className="message-card__to">{moment(Number(message.internalDate)).fromNow()}</div>
						)}
					</div>
					<div className="message-card__head-side">
						{expanded && <span>{dateStr}</span>}
						<button
							className={`message-card__star${message.isStarred ? " is-starred" : ""}`}
							onClick={this.onStarClick}
							title={message.isStarred ? "Unstar" : "Star"}
						>
							<Icon.Star size={16} />
						</button>
					</div>
				</div>

				{!expanded && <div className="message-card__snippet">{decodeEntities(message.snippet)}</div>}

				{expanded && (
					<div className="message-card__body">
						{html ? (
							<div className="message-card__body-html" dangerouslySetInnerHTML={{ __html: html }} />
						) : (
							<div className="message-card__body-html" style={{ whiteSpace: "pre-wrap" }}>
								{fallbackText || decodeEntities(message.snippet)}
							</div>
						)}

						{message.attachments && message.attachments.length > 0 && (
							<div className="message-card__attachments">
								{message.attachments.map(att => (
									<AttachmentChip key={att.attachmentId} accountId={accountId} attachment={att} />
								))}
							</div>
						)}
					</div>
				)}
			</div>
		);
	}
}

export default MessageCard;
